'use client';

export function useIsExperimentFullSolution() {
    return true;
}
